import type { ReactNode } from 'react';

import TransactionDetailsRowLeft from './TransactionDetails.RowLeft';
import TransactionDetailsRowRight from './TransactionDetails.RowRight';

const TransactionDetailsRow = ({ children, label, value }: { children?: ReactNode; label?: string; value?: string | number }) => (
	<div className='transaction-details_content_row border-bottom-dark-navy last-child'>
		{label ? <TransactionDetailsRowLeft label={label} /> : null}
		{value ? <TransactionDetailsRowRight value={value} /> : children}
	</div>
);

export default TransactionDetailsRow;
